// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cZF4","importantInfo":"styles_importantInfo__3ZEIx"};